import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';

import { ApiStore, SearchType, SuperType } from '@fry/lib/store';
import { APIService } from '@fry/lib/api';
import { guid } from '@fry/lib/utils';

import { EventType } from './event-type';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventTypesStore extends ApiStore<EventType> {
  AssociatedModel = EventType;

  docType = 'eventType';
  endpoint = 'event-types';
  superType = SuperType.Org;
  searchType = SearchType.REMOTE;

  constructor(api: APIService) {
    super(api);
  }

  duplicate(orig: EventType): EventType {
    const doc = cloneDeep(orig.doc);
    doc._id = guid();
    doc.name = `Copy of ${doc.name}`;
    delete doc._rev;
    return this.createObject(doc);
  }

  searchStub(params: any = {}): Observable<{id: string; name: string, nextVersion: string}[]> {
    return this.api.post(`${this.endpoint}/stub`, params);
  }
}
